<template>
  <div>
    <van-tabs v-model="active" @change="change" sticky color="#3E78F7">
        <van-tab title="党务公开"><xxgkCard v-if="active == '0' " code="01" title="党务公开"></xxgkCard></van-tab>
        <van-tab title="村务公开"><xxgkCard v-if="active == '1' " code="02" title="村务公开"></xxgkCard></van-tab>
        <van-tab title="财务公开"><xxgkCard v-if="active == '2' " code="03" title="财务公开"></xxgkCard></van-tab>
    </van-tabs>
  </div>
</template>

<script>
import xxgkCard from '@/views/xxgk/xxgk.vue'
  export default {
    components:{
        xxgkCard
    },
    data() {
        return {
            active: 0,
        }
    },
    created() {
    },
    methods:{
        change(idx){
            console.log("当前标签下标",idx);
        }
    }
  }
</script>

<style scoped>

</style>